export const PERIODS = [["week", "Semaine"], ["month", "Mois"], ["quarter", "Trimestre"], ["semester", "Semestre"], ["year", "Année civile"], ["nba_season", "Saison NBA"], ["custom", "Période personnalisée"]];
export const PHASES = [["full", "Saison complète"], ["regular", "Saison régulière"], ["playoffs", "Séries éliminatoires"]];
export const PRESET_INFO = {
  detente: { label: "Détente", text: "+3 par bon choix, 0 si raté, +3 à 3 de suite. Sans pronostics bonus." },
  competition: { label: "Compétition", text: "+5 / −3, bonus +5 à 3 de suite et +10 à 5 de suite. 2 pronostics bonus par match." },
  expert: { label: "Expert", text: "+5 / −5, bonus +8 à 3 de suite. 3 pronostics bonus par match." },
};
export const ADV_LABELS = { total_points: "Total de points", margin: "Écart final", top_scorer: "Meilleur marqueur", top_assists: "Meilleur passeur", top_rebounder: "Meilleur rebondeur" };

export const Select = ({ value, onChange, options, testId, className = "" }) => (
  <select value={value} onChange={(e) => onChange(e.target.value)} data-testid={testId}
    className={`w-full rounded-xl border border-white/10 bg-[#05070D] px-3 py-2.5 text-sm text-white outline-none focus:border-[#B7F52A]/60 ${className}`}>
    {options.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
  </select>
);
